export default __webpack_public_path__ + "static/media/ten.e7899ac9.png";